import { computed } from 'vue';

import { useTenantsStore } from '@/stores/tenants';
import { hasBaseCarrierWorkplaceSubscription, hasCarrierWorkplaceSubscription } from '@/domains/permissions/subscription';
import { canBrowseWalletsByRole } from '@/domains/permissions/role/wallets';

export const getIsBillingWalletBlockShown = (): boolean => {
  const tenantsStore = useTenantsStore();

  const getHasOpenClosedBiddingAdditionalSubscription = computed(
    () => tenantsStore.getHasOpenClosedBiddingAdditionalSubscription,
  );

  return canBrowseWalletsByRole()
    && (hasCarrierWorkplaceSubscription() || hasBaseCarrierWorkplaceSubscription())
    && getHasOpenClosedBiddingAdditionalSubscription.value;
};
